jQuery(document).ready(function($) {
    $(".wcj_product_input_fields ").prop("readonly", true);
  })
  